import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import Select from "react-select";
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultDrawer from '../../../../../components/Drawers/Default';
import SelectCustomStyles from '../../../../../utils/styles/reactSelect';
import { get } from '../../../../../utils/helpers/api';

const EMPTY_FILTERS = {
  search: '',
  category_id: '',
  type: '',
  min_selling_price: '',
  max_selling_price: '',
  min_cost_price: '',
  max_cost_price: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    initData();
  }, [isOpen]);

  const initData = async () => {
    const data = await get("/inventory/products/create");
    if (data?.success) {
      setCategories(data.categories.data ?? data.categories);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <DefaultDrawer
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={filtersData.search}
            onChange={(e) => setFiltersData({...filtersData, search: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('inventory.category')}: </Label>
          <Select
            options={categories.map(c => ({ value: c.id, label: c.name }))}
            styles={SelectCustomStyles}
            value={categories.map(c => ({ value: c.id, label: c.name })).find(o => o.value === filtersData.category_id) || null}
            onChange={selected => setFiltersData({ ...filtersData, category_id: selected ? selected.value : null })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.type')}: </Label>
          <Input type="select" name="type" value={filtersData.type} onChange={(e) => setFiltersData({...filtersData, type: e.target.value})}>
            <option value="">{ t('common.select') }</option>
            <option value="raw-material">{t('inventory.rawMaterials')}</option>
            <option value="finished">{t('inventory.finishedGoods')}</option>
            <option value="semi-finished">{t('inventory.semiFinishedGoods')}</option>
            <option value="trading">{t('inventory.tradingGoods')}</option>
            <option value="packaging">{t('inventory.packagingMaterials')}</option>
            <option value="non-stock">{t('inventory.nonStockItems')}</option>
            <option value="tools">{t('inventory.tools')}</option>
            <option value="service">{t('inventory.service')}</option>
          </Input>
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('inventory.minSellingPrice')}</Label>
          <Input
            type="number"
            value={filtersData.min_selling_price}
            onChange={(e) => setFiltersData({...filtersData, min_selling_price: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('inventory.maxSellingPrice')}</Label>
          <Input
            type="number"
            value={filtersData.max_selling_price}
            onChange={(e) => setFiltersData({...filtersData, max_selling_price: e.target.value})}
          />
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('inventory.minCostPrice')}</Label>
          <Input
            type="number"
            value={filtersData.min_cost_price}
            onChange={(e) => setFiltersData({...filtersData, min_cost_price: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('inventory.maxCostPrice')}</Label>
          <Input
            type="number"
            value={filtersData.max_cost_price}
            onChange={(e) => setFiltersData({...filtersData, max_cost_price: e.target.value})}
          />
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('common.addedAfter')}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.filter')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.cancel')}
        </DefaultButton>
      </div>
    </DefaultDrawer>
  );
}

export default FiltersDrawer;